import { ArrowRight } from "lucide-react";

const HERO_IMG =
  "https://customer-assets.emergentagent.com/job_clami-fillers-chile/artifacts/q9yq1ktc_Idea%201%20limpia%20-%20Slide%20web%20CLAMIGNON.png";

export default function ProductBanner() {
  return (
    <section
      id="banner"
      data-testid="product-banner"
      className="relative py-6 md:py-10"
    >
      <div className="max-w-[1160px] mx-auto px-4 md:px-6">
        <div className="relative rounded-[28px] md:rounded-[36px] overflow-hidden shadow-[0_30px_80px_-30px_rgba(90,72,201,0.35)]">
          {/* Background image (full bleed) */}
          <div
            className="absolute inset-0 bg-cover bg-center md:bg-right"
            style={{ backgroundImage: `url(${HERO_IMG})` }}
            aria-hidden="true"
          />
          {/* Readability veil — strong on left for content, transparent on right (product side) */}
          <div className="absolute inset-0 bg-gradient-to-r from-white/98 via-white/85 to-transparent md:from-white/96 md:via-white/70 md:to-transparent" />
          {/* Top-left corner mask — hides the CLAM!GNON watermark from the background image */}
          <div className="absolute inset-0 bg-gradient-to-b from-white/85 via-white/25 to-transparent md:from-white/75 md:via-white/10 md:to-transparent" />
          {/* Mobile: darker bottom + top for text legibility over the boxes */}
          <div className="absolute inset-0 md:hidden bg-gradient-to-b from-white/90 via-white/50 to-white/85" />

          {/* Content */}
          <div className="relative grid grid-cols-12 gap-6 p-6 md:p-14 md:pt-24 lg:p-16 lg:pt-28 min-h-[420px] md:min-h-[560px] items-center">
            <div
              className="col-span-12 md:col-span-6 lg:col-span-5"
            >
              <h2 className="font-display text-3xl sm:text-4xl md:text-4xl lg:text-5xl xl:text-[52px] font-bold text-[#0B0B14] tracking-tight leading-[1.05]">
                El portafolio que ya usan las <span className="text-[#5A48C9]">clínicas top.</span>
              </h2>

              <p className="mt-5 text-base md:text-[15px] lg:text-base text-[#2A2A3A] leading-relaxed max-w-md">
                Tres jeringas. Una fórmula clínica. Grado medicinal coreano bajo KGMP e
                ISO 13485. El mismo estándar que hoy compras a distribuidor — sin el
                markup del distribuidor.
              </p>

              {/* Clinical data strip */}
              <div className="mt-7 grid grid-cols-3 gap-2 md:gap-3 max-w-md">
                <ClinicalStat k="24" u="mg/mL HA" />
                <ClinicalStat k="275–301" u="Pa · G′" />
                <ClinicalStat k="6–18" u="meses" />
              </div>

              {/* CTA */}
              <div className="mt-7 flex flex-col sm:flex-row gap-3">
                <a
                  data-testid="banner-cta-primary"
                  href="#contacto"
                  className="btn-pill btn-primary shine text-[15px] px-6 py-3.5"
                >
                  Cotizar los 3 fillers
                  <ArrowRight className="w-4 h-4" />
                </a>
              </div>

              {/* Micro clinical hook */}
              <p className="mt-6 text-[10.5px] font-semibold uppercase tracking-widest text-[#5A48C9] max-w-md">
                HA cross-linked BDDE · Lidocaína 0.3% · Isotónico ~300 mOsm/kg
              </p>
            </div>

            {/* Right area — image products live here (empty grid space, content sits on left) */}
          </div>
        </div>
      </div>
    </section>
  );
}

function ClinicalStat({ k, u }) {
  return (
    <div className="rounded-2xl bg-white/80 backdrop-blur border border-black/[0.06] px-3 py-3 md:px-4 md:py-4">
      <div className="font-display text-2xl md:text-3xl font-bold text-[#0B0B14] tracking-tight leading-none">
        {k}
      </div>
      <div className="mt-1.5 text-[10px] md:text-[11px] font-semibold uppercase tracking-widest text-[#5A48C9]">
        {u}
      </div>
    </div>
  );
}
